<h2>CONDITIONS GÉNÉRALES D'UTILISATION DU PROGRAMME DE FIDÉLITÉ</h2>
<p>Contenu à venir.</p>
